import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { ConfirmationModalComponent } from '../../../../../core/shared/components/modals/confirmation-modal/confirmation-modal.component';
import { Group } from '../../../../../core/shared/models/group.model';
import { NoWhiteSpaceValidator } from '../../../../../core/shared/validators/whitespace-validator';
import {
  AddUpdateGroup,
  DeleteGroup,
} from '../../../../../core/shared/actions/group.actions';
import { GroupDetailsListComponent } from '../../lists/group-details-list/group-details-list.component';
@Component({
  selector: 'app-group-modal',
  templateUrl: './group-modal.component.html',
  styleUrls: ['./group-modal.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    GroupDetailsListComponent,
    MatSnackBarModule,
    MatFormField, MatLabel, MatInput, MatError, MatIcon, MatButton, MatIconButton,
  ],
})
export class GroupModalComponent implements OnInit {
  @Input() public group?: Group;
  @Input() public formMode = 'New';
  @Input() public editGroup = false;
  @Input() public applicationName!: string;

  private formSubscription: Subscription = new Subscription();

  entryForm!: FormGroup;
  error: string | undefined;
  id: any;

  constructor(
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private store: Store,
    private snackBar: MatSnackBar
  ) {
    this.createForm();
   
  }

  ngOnInit() {
  
    if (this.group) {
      this.entryForm.patchValue({
        group_name: this.group.group_name,
        Description: this.group.Description,
        application: this.group.application,
      });

      this.editGroup = true;
    } else {
      this.editGroup = false;
    }
  }

  //   // Handle Create  update button click
  onCreate_Update(): void {
    this.entryForm.controls['group_name'].setValue(
      this.entryForm.controls['group_name'].value.trim()
    );
    const groupname = this.entryForm.controls['group_name'].value;
    this.entryForm.controls['application'].setValue(this.applicationName);
    this.formSubscription.add(
      this.store
        .dispatch(
          new AddUpdateGroup(this.applicationName, this.entryForm.value)
        )
        .subscribe(
          (resp: any) => {
            this.activeModal.close();
            this.showSnackBar('Group list updated successfully!', false);
          },
          (error) => {
            this.activeModal.close();
            this.showSnackBar('An error occurred:' + error.error.message, true);
          }
        )
    );
  }

  openConfirmModal(message: string) {
    // Open modal form component
    const modalRef = this.modalService.open(ConfirmationModalComponent, {});
    modalRef.componentInstance.message = message;
  
    modalRef.result.then((event) => {
      if (event == 'confirm') {
        this.onDelete();
      }
    });
  }
  // Handle Create button click

  // Handle Delete button click
  onDelete() {
    this.store
      .dispatch(new DeleteGroup(this.entryForm.controls['group_name'].value))
      .subscribe(
        (resp: any) => {
          this.activeModal.close();
          this.showSnackBar('The Group has been successfully deleted!!', false);
        },
        (error) => {
          this.activeModal.close();
          this.showSnackBar('An error occurred:' + error.error.message, true);
        }
      );
  }

  // reactive form
  private createForm() {
    this.entryForm = this.formBuilder.group({
      group_name: new FormControl('', [
        Validators.required,
        NoWhiteSpaceValidator.cannotContainSpace,
      ]),
      Description: new FormControl('', [Validators.required]),
      application: [''],
    });
  }
  showSnackBar(message: string, isError: boolean): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000, // Duration in milliseconds
      panelClass: isError ? 'error-snackbar' : 'success-snackbar', // Custom CSS classes for styling
    });
  }
  clearForm() {
    this.entryForm.reset();
  }
}
